import TableWrap from 'ui/table/TableWrap'
import TableScrollContainer from 'ui/table/TableScrollContainer'
import TableHeader from 'ui/table/TableHeader'
import { Table } from '@morningtrain/react-columns'

export default function TableWithHeaderAndFooter ({ header = null, footer = null, tableProps = {}, children }) {
  return (
    <TableWrap>
      <TableScrollContainer>
        <TableHeader>
          {header}
        </TableHeader>
        <Table {...tableProps}>
          {children}
        </Table>
        {footer}
      </TableScrollContainer>
    </TableWrap>
  )
}
